import React from "react";

function TableHeaderUsers({ usersDataState }) {
    // Count active users - check for "Active" status (case-insensitive)
    const activeUsersCount = React.useMemo(() => {
        if (!usersDataState || !Array.isArray(usersDataState)) return 0;
        
        // Debug: log all unique status values to see what we're working with
        const uniqueStatuses = [...new Set(usersDataState.map(u => u?.status).filter(Boolean))];
        if (uniqueStatuses.length > 0) {
            console.log('Unique statuses found:', uniqueStatuses);
        }
        
        return usersDataState.filter(user => {
            const status = user?.status?.trim();
            return status && status.toLowerCase() === "active";
        }).length;
    }, [usersDataState]);
    
    return (
        <div className="header-table d-flex align-items-center py-3">
            <div className="headingPage d-sm-flex align-items-center">
                <h2 className="text-nowrap">User Management</h2>
                <div className="count-items ml-3 mt-2 mt-sm-0">
                    {activeUsersCount} Active Users
                </div>
            </div>
            {/* Hidden Import and Add New Users buttons */}
            {/* <div className="actions-other ml-auto d-flex align-items-center">
                <Button className="btn-white mr-3" size="lg">
                    <Iconsax iconName="upload-cloud" fill="#344054" size={25} />
                    <span className="ml-2">Import</span>
                </Button>
                <AddNewUser />
            </div> */}
        </div>
    );
}

export default TableHeaderUsers;

